const paths = {
  main: '/disaster-notices',
  detail: '/disaster-notices/:id',
  answer: '/disaster-notices/answer/detail',
};

export default paths;
